/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Plan_Tab_Active_UntilInputs */



/**
* | output |
* | --- |
* | "Active until {date}" |
*
* @param {Plan_Tab_Active_UntilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_active_until = /** @type {((inputs: Plan_Tab_Active_UntilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Active_UntilInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktiv bis ${i?.date}`)
	return /** @type {LocalizedString} */ (`Active until ${i?.date}`)
});